let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6CWou")).then(() => parcelRequire('7GihV'));